





















import { PartnerPractice } from '@/shared/partner-practice';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class PartnerPracticeOriginalSources extends Vue {
    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;

    @Prop({ required: true }) private partnerPractice!: PartnerPractice;

    private get filteredClientOriginalSourceTypes(): Array<ClientOriginalSourceType> {
        return this.clientOriginalSourceTypes == null
            ? []
            : this.clientOriginalSourceTypes.filter((type) => !type.isArchived || this.partnerPractice.originalSourceTypes.some((t) => t === type.id))
                .sort((t1, t2) => {
                    if (t1.value > t2.value) { return 1; }
                    if (t1.value < t2.value) { return -1; }
                    return 0;
                });
    }

    private get indexModulus(): number {
        const bar = this.clientOriginalSourceTypes.length % 4;
        return this.clientOriginalSourceTypes.length - bar;

    }
}
